import { Popover } from 'antd';
import { AbstractTooltipProps } from 'antd/es/tooltip';
import React, { CSSProperties, ReactNode } from 'react';
import styles from 'src/app/components/InfoTooltipComponent/InfoTooltip.module.scss';
import { useAppSelector } from 'src/app/redux/hook';
import InfoIcon from 'src/icons/InfoIcon';

export interface IInfoTooltipProps {
  tooltipContent: string | ReactNode;
  props?: AbstractTooltipProps;
  style?: CSSProperties;
}

// This component render info tooltip with given text and optional props
const InfoTooltip: React.FC<IInfoTooltipProps> = ({ tooltipContent, props, style }) => {
  const { theme } = useAppSelector((state) => state.configContent);

  return (
    <sup>
      <Popover
        placement={props?.placement || 'bottom'}
        color="#92AABB"
        content={
          <div className={styles.popoverStyle}>
            <p>{tooltipContent}</p>
          </div>
        }
      >
        <div style={style}>
          <InfoIcon color={theme.colors.quoteBgc} style={{ cursor: 'help' }} />
        </div>
      </Popover>
    </sup>
  );
};

export default InfoTooltip;
